import { TRole } from '../pages/auth/interfaces';
import { menuConfigItems } from '../constants/menuConfigItems';
import { UserRoleType } from '../interfaces/user';

const {
  profile,
  vendorProducts,
  products,
  orders,
  vendorsAdmin,
  buyersAdmin,
  legal,
  settings,
  catalogForUser,
  buyersOrders,
  usersManager,
  ordersVendor,
} = menuConfigItems;

const getManagerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [catalogForUser, profile, usersManager, settings, legal],
  },
});

const getAdminMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [products, orders, vendorsAdmin, buyersAdmin, settings, legal],
  },
});

const getVendorMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [vendorProducts, ordersVendor],
  },
});

const getBuyerMenu = () => ({
  header: {
    self: {},
    items: [buyersOrders],
  },
  aside: {
    self: {},
    items: [],
  },
});

const getGuestMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [],
  },
});

const getMenuConfig = (
  userRoles: TRole[] | UserRoleType[] = ['ROLE_BUYER'],
  isAuthorized?: boolean
) => {
  if (isAuthorized) {
    if (userRoles === undefined) {
      return getGuestMenu();
    }
    if (userRoles[0] === 'ROLE_ADMIN') {
      return getAdminMenu();
    }
    if (userRoles[0] === 'ROLE_MANAGER') {
      return getManagerMenu();
    }
    if (userRoles[0] === 'ROLE_VENDOR') {
      return getVendorMenu();
    }
    if (userRoles[0] === 'ROLE_BUYER') {
      return getBuyerMenu();
    }
    if (userRoles[0] === 'ROLE_VENDOR_STAFF') {
      return getVendorMenu();
    }
    if (userRoles[0] === 'ROLE_BUYER_STAFF') {
      return getBuyerMenu();
    }
  } else {
    return getGuestMenu();
  }
};

export default getMenuConfig;
